module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }